import axios from '../axios'
import { getParameterByName } from './../../utils/util'

const token = getParameterByName('token');

// 用法示例
const paramValue = getParameterByName('yourParamName');

const getBrandList = params => axios({
  url: '/recycle/product/brand/list',
  method: 'get',
  params
})

const getModelList = params => axios({
  url: '/recycle/product/product/list',
  method: 'get',
  params
})

const photoPolicyPutUpload = data => axios({
  url: '/file/upload-file',
  method: 'post',
  data
})

const uploadDetectionAttachments = data => axios({
  url: '/yihuan/detection/upload-detection-attachments',
  method: 'post',
  data
})

const orderDetail = data => axios({
  url: '/user/order/detail?token=' + token,
  method: 'post',
  data
})

const uploadFile = data => axios({
  url: '/user/file/upload-file?token=' + token,
  method: 'post',
  data
})

const uploadImg = (uploadUrl, formData) => axios({
  url: uploadUrl,
  method: 'post',
  data: formData,
  headers:{'Content-Type':'multipart/form-data'}
})

// 获取 OSS POST 上传授权（params 需含 contentType；token 从 URL 自动带上）
const policyPutUpload = (params = {}) => axios({
  url: '/file/policyPostUpload',
  method: 'get',
  params: {
    ...params,
    token: getParameterByName('token')
  }
})

const submit = data => axios({
  url: '/user/order/oldImeiPic/submit?token=' + token,
  method: 'post',
  data
})

const getExpressBill = data => axios({
  url: '/user/logistics/getExpressBill/async?token=' + token,
  method: 'post',
  data
})

const orderAccept = params => axios({
  url: '/user/order/accept?token=' + token,
  method: 'get',
  params
})

const orderReject = params => axios({
  url: '/user/order/reject?token=' + token,
  method: 'get',
  params
})

const getOldImeiPic = data => axios({
  url: '/user/order/oldImeiPic/get?token=' + token,
  method: 'post',
  data
})


export {
  getBrandList,
  getExpressBill,
  getModelList,
  getOldImeiPic,
  orderAccept,
  orderDetail,
  orderReject,
  photoPolicyPutUpload,
  policyPutUpload,
  submit,
  uploadDetectionAttachments,
  uploadFile,
  uploadImg}
